var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navbar'),_c('main',{staticClass:"page-content"},[_c('router-view',{scopedSlots:_vm._u([{key:"default",fn:function({ Component }){return [_c('transition',{attrs:{"name":"fade-slide","mode":"out-in"}},[_c(Component,{tag:"component"})],1)]}}])})],1),(!_vm.$route.meta.hideFooter)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }